import { Link } from "react-router-dom";

import MemberCredentialCard from "../member/member-credential-card/MemberCredentialCard";
import MemberDeleted from "../member/member-deleted/MemberDeleted";
import ScheduleList from "../schedule/schedule-list/ScheduleList";
import MeetingCard from "../meeting/meeting-card/MeetingCard";
import { ButtonPrint } from "../../containers";
import SecretaryReports from "../secretary/reports/SecretaryReports";

export default function DashboardSecretary() {
  return (
    <div id="page-dashboad-secretary" className="uk-section uk-section-muted uk-padding-small">
      <div className="uk-container">
        <div className="uk-grid-small uk-flex-center uk-text-center uk-margin-bottom" uk-grid="true">
          <Link className="uk-button uk-button-success uk-button-small uk-margin-right" 
            to={`/secretaria/cartas`}>
            Cartas Emitidas
          </Link>
          <Link className="uk-button uk-button-danger uk-button-small uk-margin-right"
            to={`/secretaria/anuidades`}>
            Anuidades
          </Link>
          <Link className="uk-button uk-button-primary uk-button-small" 
            to={`/secretaria/protocolos`}>
            Protocolos
          </Link>
          <ButtonPrint showSecretaryDocs />
        </div>
        <div className="uk-grid-small uk-margin-bottom" uk-grid="true">
          <div className="uk-width-1-3@m">
            <MeetingCard />                        
          </div>
          <div className="uk-width-1-3@m">
            <MemberCredentialCard />                        
          </div>
          <div className="uk-width-1-3@m">
            <MemberDeleted />
            <SecretaryReports />
          </div>
          <div className="uk-width-1@m">
            <ScheduleList />
          </div>
        </div>
      </div>
    </div>
  )
}